"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
function FormPlaylists(_a) {
    var video = _a.video, channel = _a.channel, onChange = _a.onChange;
    var playlists = ra_fetch_1.useApi('backend').index('playlists', {
        channel_id: channel.id,
        sort: 'position asc',
        hidden: 0,
    })[0];
    if (!playlists.data.length) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement(storybook_1.Videos.FormList, { type: 'playlists', heading: 'Toevoegen aan afspeellijst', items: playlists.data, video: video, onChange: function (checked, id) { return onChange('playlists', checked, id); } });
}
exports.default = FormPlaylists;
